import { Image, Spacer } from '@zillow/constellation';
import { Heading, Label, LabeledControl, Radio } from '@zillow/constellation-10';

import { LEASES_SURVEY_CONTENT, STEPS } from '../constants';

import { StyledHeroBackground } from '../StyledComponents';

type Props = {
  onSelect: (param: Record<string, boolean | null>) => void;
  step: (typeof STEPS)[keyof typeof STEPS] & string;
  selectedOption: boolean;
};

const LeasesSurvey = ({ onSelect, selectedOption, step = STEPS.LEASES_SURVEY }: Props) => {
  return (
    <div data-testid="LeasesSurvey">
      {LEASES_SURVEY_CONTENT[step].HERO_IMAGE && (
        <StyledHeroBackground data-testid="CreateLeaseHero" display="flex" alignItems="center" justifyItems="center">
          <Image src={LEASES_SURVEY_CONTENT[step].HERO_IMAGE} alt={LEASES_SURVEY_CONTENT[step].HERO_IMAGE_ALT} />
        </StyledHeroBackground>
      )}

      <Spacer data-testid="LeasesSurveyContentContainer" marginTop="sm" marginBottom="sm">
        <Heading level={4}>{LEASES_SURVEY_CONTENT[step].HEADING}</Heading>

        {LEASES_SURVEY_CONTENT[step].BODY && (
          <Spacer marginTop="sm">
            <Heading level={6}>{LEASES_SURVEY_CONTENT[step].BODY}</Heading>
          </Spacer>
        )}
      </Spacer>

      {LEASES_SURVEY_CONTENT[step].SURVEY_OPTIONS.map((option) => (
        <LabeledControl
          key={`LeasesSurvey-Radio-${option.label}`}
          label={<Label>{option.label}</Label>}
          control={
            <Radio
              value={String(option.value)}
              onChange={() => onSelect({ [LEASES_SURVEY_CONTENT[step].DB_VALUE]: option.value })}
              checked={selectedOption === option.value}
            />
          }
        />
      ))}
    </div>
  );
};

export default LeasesSurvey;
